export const UPDATE_THEME = '[APP] UPDATE_THEME';

export type ITypeThemeApp = 'light' | 'dark';

export interface IAppState {
  theme: ITypeThemeApp;
}
